module.exports = __webpack_public_path__ + "img/icon_h-welfare.332182a6.png";